import { Skeleton } from "@/core/components/ui/skeleton";
import { Stack } from "@/core/components/ui/stack";
import { Tabs } from "@/core/components/ui/tabs";
import { BusinessSettingsSidebarWrapper } from "@/business-settings/common/business-settings-sidebar-wrapper";

export const ReferralPaymentsSidebarSkeleton = () => (
  <BusinessSettingsSidebarWrapper>
    <Stack
      direction="row"
      justify="between"
      align="center"
      className={"flex-none bg-bg-secondary/50 p-6"}
    >
      <Stack gap={"md"}>
        <Skeleton className="h-2 w-10"></Skeleton>
        <Skeleton className="h-3 w-20"></Skeleton>
      </Stack>
      <Stack direction="row" align="center" gap="sm"></Stack>
    </Stack>
    <div className="flex-1 overflow-hidden">
      <Stack gap="none" fullWidth className="h-full">
        <Tabs className="flex w-full flex-1 flex-col overflow-hidden px-6">
          <Stack fullWidth className="pt-4">
            <Stack fullWidth gap="lg" className="mt-2">
              <Stack direction="row" justify="between" gap="md">
                <Stack fullWidth gap="sm" className="h-[44px]">
                  <Skeleton className="h-[16px] w-3/5"></Skeleton>
                  <Skeleton className="h-[20px] w-4/5"></Skeleton>
                </Stack>

                <Stack fullWidth gap="sm" className="h-[44px]">
                  <Skeleton className="h-[16px] w-3/5"></Skeleton>
                  <Skeleton className="h-[20px] w-4/5"></Skeleton>
                </Stack>
              </Stack>

              <Stack direction="row" justify="between" gap="md">
                <Stack fullWidth gap="sm" className="h-[44px]">
                  <Skeleton className="h-[16px] w-3/5"></Skeleton>
                  <Skeleton className="h-[20px] w-4/5"></Skeleton>
                </Stack>

                <Stack fullWidth gap="sm" className="h-[44px]">
                  <Skeleton className="h-[16px] w-3/5"></Skeleton>
                  <Skeleton className="h-[20px] w-4/5"></Skeleton>
                </Stack>
              </Stack>

              <Stack fullWidth gap="sm" className="h-[44px]">
                <Skeleton className="h-[16px] w-20"></Skeleton>
                <Skeleton className="h-[20px] w-12"></Skeleton>
              </Stack>

              <Stack fullWidth gap="sm" className="h-[44px]">
                <Skeleton className="h-[16px] w-20"></Skeleton>
                <Skeleton className="h-[20px] w-12"></Skeleton>
              </Stack>
            </Stack>
          </Stack>
        </Tabs>
      </Stack>
    </div>
  </BusinessSettingsSidebarWrapper>
);
